import type React from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { Link } from '@vlabs/uikit/components/controls/link/Link';
import type { LinkProps } from '@vlabs/uikit/components/controls/link/Link';

import { useGoToCardTranslation } from './i18n';
import { generateLink } from './link';
import type { GoToCardProps } from './types';

interface GoToCardLinkProps extends GoToCardProps, Omit<LinkProps, 'children' | 'icon' | 'to'> {}

function GoToCardLink({
  cardId,
  ...props
}: GoToCardLinkProps): React.JSX.Element {
  const { t } = useGoToCardTranslation();

  return (
    <Link
      icon={<ArrowInCircleRightIcon />}
      size="medium"
      target="_blank"
      to={generateLink(cardId)}
      {...props}
    >
      {t('title')}
    </Link>
  );
}

export { GoToCardLink };
